import { Lease, LeaseStatus } from '../../types/lease'
import {
    SET_BILLS,
    SET_BILLS_LOADING,
    SET_BILLS_ERROR,
    BillingActionTypes,
    SET_SELECTED_BILL,
} from './types'
import { ThunkAction } from 'redux-thunk'
import { RootState } from '..'
import { axiosInstance } from '../../helpers/axios'
import { Bill } from '../../types/bills'
import { LeaseActionTypes } from '../Lease/types'
import { setSelectedLease } from '../Lease/action'

export const setBills = (bills: Bill[] | null): BillingActionTypes => ({
    type: SET_BILLS,
    bills,
})

export const setBillsLoading = (loading: boolean): BillingActionTypes => ({
    type: SET_BILLS_LOADING,
    loading,
})

export const setBillsError = (error: string | null): BillingActionTypes => ({
    type: SET_BILLS_ERROR,
    error,
})

export const setSelectedBill = (bill: Bill | null): BillingActionTypes => ({
    type: SET_SELECTED_BILL,
    bill,
})

export const fetchBills = (
    leaseId?: number,
): ThunkAction<Promise<void>, RootState, unknown, BillingActionTypes> => {
    return async (dispatch) => {
        try {
            dispatch(setBillsLoading(true))
            const response = await axiosInstance.get('/rent/tenant-bills/', {
                params: {
                    lease_id: leaseId,
                },
            })
            console.log('tenant bills response:', response.data)
            dispatch(setBills(response.data))
            dispatch(initializeSelectedBill(response.data))
        } catch (error) {
            console.error('Error fetching bills:', error)
            dispatch(
                setBillsError(
                    error instanceof Error
                        ? error.message
                        : 'Failed to fetch bills',
                ),
            )
        } finally {
            dispatch(setBillsLoading(false))
        }
    }
}

// Initialize so that the selected bill is the most recent bill
// for the Pay Now Card
export const initializeSelectedBill = (
    bills: Bill[],
): ThunkAction<void, RootState, unknown, BillingActionTypes> => {
    return (dispatch) => {
        if (bills.length > 0) {
            // Try to find a current lease first
            const currentBill = bills.find((bill) => bill.status === 'pending')
            if (currentBill) {
                dispatch(setSelectedBill(currentBill))
                return
            }
            // If no current lease, find the most recent one
            const sortedBills = [...bills].sort(
                (a, b) =>
                    new Date(b.sent_at).getTime() -
                    new Date(a.sent_at).getTime(),
            )
            dispatch(setSelectedBill(sortedBills[0]))
        } else {
            dispatch(setSelectedBill(null))
        }
    }
}
